"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.RadioFill = exports.RadioLabel = exports.RadioButton = exports.Input = exports.RadioContainer = void 0;

var _tslib = require("tslib");

var _styledComponents = _interopRequireDefault(require("styled-components"));

var _Flex = _interopRequireDefault(require("../../../../Layout/Flex"));

var _Label = _interopRequireDefault(require("../../Label"));

function _interopRequireDefault(obj) {
  return obj && obj.__esModule ? obj : {
    default: obj
  };
}

var RadioContainer = (0, _styledComponents.default)(_Flex.default)(templateObject_1 || (templateObject_1 = (0, _tslib.__makeTemplateObject)(["\n  margin: 0;\n  position: relative;\n"], ["\n  margin: 0;\n  position: relative;\n"])));
exports.RadioContainer = RadioContainer;
RadioContainer.displayName = 'RadioContainer';
RadioContainer.defaultProps = {
  alignItems: 'center',
  flexDirection: 'row'
};

var Input = _styledComponents.default.input(templateObject_2 || (templateObject_2 = (0, _tslib.__makeTemplateObject)(["\n  opacity: 0;\n  position: absolute;\n  width: 20px;\n  height: 20px;\n  cursor: pointer;\n\n  :focus ~ label {\n    outline: 2px solid ", ";\n    outline-offset: 2px;\n  }\n\n  :focus-visible ~ label {\n    outline: 2px solid ", ";\n    outline-offset: 2px;\n  }\n"], ["\n  opacity: 0;\n  position: absolute;\n  width: 20px;\n  height: 20px;\n  cursor: pointer;\n\n  :focus ~ label {\n    outline: 2px solid ", ";\n    outline-offset: 2px;\n  }\n\n  :focus-visible ~ label {\n    outline: 2px solid ", ";\n    outline-offset: 2px;\n  }\n"])), function (_a) {
  var theme = _a.theme;
  return theme.colors.black;
}, function (_a) {
  var theme = _a.theme;
  return theme.colors.black;
});

exports.Input = Input;

var RadioButton = _styledComponents.default.div(templateObject_3 || (templateObject_3 = (0, _tslib.__makeTemplateObject)(["\n  appearance: none;\n  display: inline-block;\n  position: absolute;\n  background-color: ", ";\n  color: ", ";\n  height: 20px;\n  width: 20px;\n  border: 2px solid ", ";\n  border-radius: 50%;\n  cursor: pointer;\n  pointer-events: none;\n\n  > div { display: none; }\n\n  input:checked ~ & {\n    > div { display: block; }\n  }\n"], ["\n  appearance: none;\n  display: inline-block;\n  position: absolute;\n  background-color: ", ";\n  color: ", ";\n  height: 20px;\n  width: 20px;\n  border: 2px solid ", ";\n  border-radius: 50%;\n  cursor: pointer;\n  pointer-events: none;\n\n  > div { display: none; }\n\n  input:checked ~ & {\n    > div { display: block; }\n  }\n"])), function (_a) {
  var theme = _a.theme;
  return theme.colors.white;
}, function (_a) {
  var theme = _a.theme;
  return theme.colors.orange;
}, function (_a) {
  var theme = _a.theme;
  return theme.colors.orange;
});

exports.RadioButton = RadioButton;
RadioButton.displayName = 'RadioButton';
var RadioLabel = (0, _styledComponents.default)(_Label.default)(templateObject_4 || (templateObject_4 = (0, _tslib.__makeTemplateObject)(["\n  padding-left: 32px;\n"], ["\n  padding-left: 32px;\n"])));
exports.RadioLabel = RadioLabel;
RadioLabel.displayName = 'RadioLabel';
RadioLabel.defaultProps = {
  mx: 0,
  my: '1'
};

var RadioFill = _styledComponents.default.div(templateObject_5 || (templateObject_5 = (0, _tslib.__makeTemplateObject)(["\n  position: absolute;\n  top: 4px;\n  left: 4px;\n  width: 8px;\n  height: 8px;\n  border-radius: 50%;\n  background: ", ";\n"], ["\n  position: absolute;\n  top: 4px;\n  left: 4px;\n  width: 8px;\n  height: 8px;\n  border-radius: 50%;\n  background: ", ";\n"])), function (_a) {
  var theme = _a.theme;
  return theme.colors.orange;
});

exports.RadioFill = RadioFill;
var templateObject_1, templateObject_2, templateObject_3, templateObject_4, templateObject_5;